import { render, staticRenderFns } from "./BillingTransactionsClassificationTab.vue?vue&type=template&id=aac64570&scoped=true"
import script from "./BillingTransactionsClassificationTab.vue?vue&type=script&lang=js"
export * from "./BillingTransactionsClassificationTab.vue?vue&type=script&lang=js"
import style0 from "./BillingTransactionsClassificationTab.vue?vue&type=style&index=0&id=aac64570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac64570",
  null
  
)

export default component.exports